module.exports = __webpack_public_path__ + "assets/img/office-building-budapart-640.c740c0bb.webp";